import { render, staticRenderFns } from "./ChapterEditor.vue?vue&type=template&id=02ff6788&scoped=true&"
import script from "./ChapterEditor.vue?vue&type=script&lang=js&"
export * from "./ChapterEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff6788",
  null
  
)

export default component.exports